import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {useEffect, useState} from "react";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoToggleOutlined
} from "@moeindal/base-raiko-panel-components";

export const ManagerBanAccess = ({managerId, service}) => {

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (managerId && managerId >= 0) {
            getManagerEnabledStatus()
        }
    }, [])

    function getManagerEnabledStatus() {
        loading.show()
        service.getManagerEnabled(managerId)
            .then(response => {
                setBanState(response.enabled)
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    const [banState, setBanState] = useState(true);

    function changeManagerEnabledState(state) {
        loading.show()
        service.changeManagerEnabledState(managerId, state)
            .then(response => {
                setBanState(state)

                if (state)
                    snackbar.showSuccessMessage("دسترسی مدیر به سامانه با موفقیت آزاد شد.")
                else
                    snackbar.showWarningMessage("دسترسی مدیر به سامانه با موفقیت مسدود شد.")


                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem;`}>
            <RaikoSectionContainer title={"مسدود سازی"}>
                <RaikoGridOneColumn>
                    <Alert severity="error" className={css`width: 100%;`}>
                        <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                        <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                          margin-top: 16px;
                        `}>
                            <span>با مسدود سازی مدیر دسترسی مدیر به پنل بسته خواهد شد.</span>
                        </div>
                    </Alert>
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی"}
                        setChecked={state => {
                            changeManagerEnabledState(!state)
                        }}
                        checked={!banState}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}